export default __webpack_public_path__ + "static/ed-2df5de02335f21f9a0b3bc020cc0a5c7.jpg";